<template>
    <form @submit.prevent="onSubmit">
        <v-row>
            <v-col cols="12">
                <v-text-field label="Nombre del Tratamiento" v-model="localTratamiento.nombre" />
            </v-col>
            <v-col cols="12">
                <v-textarea label="Descripción" v-model="localTratamiento.descripcion" />
            </v-col>
        

            <v-col cols="12">
                <!-- Imagen: type file -->
                <div class="preview-img">
                    <v-img v-if="imagenPreview" :src="imagenPreview" width="100" height="50" contain class="mb-2"/>
                    <v-img v-else-if="localTratamiento.imagen" :src="assetAWS(localTratamiento.imagen)" width="100" height="50" contain class="mb-2"/>
                </div>
                <v-file-input label="Imagen" accept="image/*" v-model="imagenFile" @change="filledFile($event, 'imagen')" />
            </v-col>
        
            <v-col cols="12">
                <!-- Imagen Nombre -->
                <div class="preview-img">
                    <v-img v-if="nombreImagenPreview" :src="nombreImagenPreview" width="100" height="50" contain class="mb-2"/>
                    <v-img v-else-if="localTratamiento.nombre_imagen" :src="assetAWS(localTratamiento.nombre_imagen)" width="100" height="50" contain class="mb-2"/>
                </div>
                <v-file-input label="Imagen Nombre" accept="image/*" v-model="nombreImagenFile" @change="filledFile($event, 'nombre_imagen')" />
            </v-col>
        
            <v-col cols="12">
                <!-- Icono despues del nombre -->
                <div class="preview-img">
                    <v-img v-if="iconAfterNombrePreview" :src="iconAfterNombrePreview" width="100" height="50" contain class="mb-2"/>
                    <v-img v-else-if="localTratamiento.icon_after_nombre" :src="assetAWS(localTratamiento.icon_after_nombre)" width="100" height="50" contain class="mb-2"/>
                </div>
                <v-file-input label="Icono después del nombre" accept="image/*" v-model="iconAfterNombreFile" @change="filledFile($event, 'icon_after_nombre')" />
            </v-col>

            <v-col cols="12">
                <v-switch
                    v-model="localTratamiento.estado"
                    label="Estado"
                    :true-value="1"
                    :false-value="0"
                />
            </v-col>

            <v-col cols="12" class="btns-form">
                <v-btn text @click="cancel">
                    <v-icon left>mdi-cancel</v-icon>
                    Cancelar
                </v-btn>
                <v-btn type="submit" color="primary">
                    <v-icon left>mdi-content-save</v-icon>
                    Guardar
                </v-btn>
            </v-col>

        </v-row>
    </form>
</template>

<script>
    import { tratamiento } from '@/models/tratamiento';

    export default {
        name: 'FormTratamiento',
        props: {
            value: {
                type: Object,
                default: () => ({
                    ...tratamiento
                }),
            }
        },
        emits: ['input','submit', 'cancel'],
        watch: {
            value(newVal) {
                if (this.sync) return;
                this.sync = true;
                this.localTratamiento = {...newVal};

                this.imagenFile = null;
                this.nombreImagenFile = null;
                this.iconAfterNombreFile = null;

                this.imagenPreview = null;
                this.nombreImagenPreview = null;
                this.iconAfterNombrePreview = null;

                this.$nextTick(() => {
                    this.sync = false;
                });
            },
            localTratamiento(newVal) {
                if (this.sync) return;
                this.sync = true;
                this.$emit('input', newVal);
                this.$nextTick(() => {
                    this.sync = false;
                });
            }
        },
        data() {
            return {
                sync : false,
                localTratamiento: { ...this.value},
                
                imagenFile: null,
                nombreImagenFile: null,
                iconAfterNombreFile: null,

                imagenPreview: null,
                nombreImagenPreview: null,
                iconAfterNombrePreview: null,
            };
        },
        methods: {
            onSubmit() {
                this.$emit('submit', {
                    ...this.localTratamiento,
                    imagen_file: this.imagenFile,
                    nombre_imagen_file: this.nombreImagenFile,
                    icon_after_nombre_file: this.iconAfterNombreFile,
                });
            },
            generatePreview(file, input) {
                if (!file) {
                    this[input] = null;
                    return;
                }
               
                const reader = new FileReader();
                reader.onload = (e) => {
                    this[input] = e.target.result || null;
                };

                reader.readAsDataURL(file);
            },
            filledFile(file, type){
                if (type == 'imagen') {
                    this.generatePreview(file, 'imagenPreview');
                } else if (type === 'nombre_imagen') {
                    this.generatePreview(file, 'nombreImagenPreview');
                } else if (type === 'icon_after_nombre') {
                    this.generatePreview(file, 'iconAfterNombrePreview');
                }


            },

            cancel() {
                this.$emit('cancel');
            }
            
        }
    };

</script>

<style scoped>
    .btns-form {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
    }

    .preview-img {
        display: grid;
        place-items: center;
        background: rgba(255, 255, 255,.5);
        margin-bottom: .5rem;
    }

</style>